import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ImageCacheService {
    //private cache = new Map<string, string>();
    private MAX_WIDTH = 350;
    private MAX_HEIGHT = 300;


    get(url: string): string | null {
        // let dataUri = localStorage.getItem(url)
        //return dataUri ? localStorage.getItem(url) : null;
        //return window.location.protocol+"//"+window.location.hostname+url;
        return url;
    }

    set(url: string, dataUrl: string): void {
        localStorage.setItem(url, dataUrl);
    }



    async fetchAndCache(url: string): Promise<string> {
        const cacheImage = this.get(url);
        if (cacheImage) return cacheImage;

        //const response = await fetch(window.location.protocol+"//"+window.location.hostname+url);
        const response = await fetch(url);

        const blob = await response.blob();
        const compressDateUrl = await this.resizeImage(blob);
        this.set(url, compressDateUrl);
        return compressDateUrl;

    }

    private resizeImage(blob: Blob): Promise<string> {

        return new Promise((reslove) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;

                if (width > this.MAX_WIDTH || height > this.MAX_HEIGHT) {
                    const aspectRatio = width / height;
                    if (width > height) {
                        width = this.MAX_WIDTH;
                        height = Math.round(width / aspectRatio);

                    } else {
                        height = this.MAX_HEIGHT;
                        width = Math.round(height * aspectRatio);
                    }
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    ctx.drawImage(img, 0, 0, width, height);
                    reslove(canvas.toDataURL('image/jpeg', 1));
                }
            };
            img.src = URL.createObjectURL(blob);
        });

    }
}
